import Topics from 'features/help/screens/Topics';
import React from 'react';

export default function TopicsPage() {
  return <Topics />;
}
